import React, {Component} from 'react';
import {connect} from 'react-redux';
import VariablesForm from '../components/VariablesForm';
import {PRESCRIPTIONS_ENUM} from '../config/prescriptions';
import {DATA_SETS} from '../Constants';
import {DEFAULT_PRESCRIPTION} from '../reducers/point_data_prescriptions';
import './Forms.css';

const META_DATA = [
  {
    row: 1,
    readonly: true,
    key: 'fms_burn',
    displayName: 'FMS Burn Name'
  },
  {
    row: 2,
    readonly: true,
    key: 'fms_prescription',
    displayName: 'FMS Prescription Burn Class'
  },
  {
    row: 3,
    key: 'prescription',
    displayName: 'Selected Prescription Burn Class',
    editDisplayName: 'Prescription Burn Class',
    enum: PRESCRIPTIONS_ENUM
  }
];

class PrescriptionsVariables extends Component {
  render() {
    return <VariablesForm data_set={DATA_SETS.PRESCRIPTIONS}
                          start_open={this.props.variables.prescription === DEFAULT_PRESCRIPTION}
                          meta_data={META_DATA}
                          variables={this.props.variables}
                          dispatch={this.props.dispatch}/>;
  }
}

const mapStateToProps = state => {
  return {
    variables: {
      fms_prescription: state.incidents.active ? state.incidents.active.properties.Prescription : undefined,
      fms_burn: state.incidents.active ? state.incidents.active.properties.Name : undefined,
      prescription: state.point_data_prescriptions.prescription
    }
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PrescriptionsVariables);



// WEBPACK FOOTER //
// ./src/containers/PrescriptionsVariables.js